<template>
  <v-window :model-value="openedTabIndex" :touch="false" @click="$emit('update:opened-tab-index', openedTabIndex)">
    <!-- TAB PROJECT SHEET -->
    <v-window-item :transition="false" :reverse-transition="false" value="projectsheet">
      <project-sheet :planning="planning" @open-project-report="$emit('open-project-report', $event)" @update="$emit('update', $event)" @reload-planning="$emit('reload-planning', $event)">
      </project-sheet>
    </v-window-item>

    <!-- TAB FILES -->
    <v-window-item :transition="false" :reverse-transition="false" value="files">
      <project-report-files :planning="planning" @open-element="$emit('open-element', $event)"></project-report-files>
    </v-window-item>

    <!-- TAB BUDGET -->
    <v-window-item :transition="false" :reverse-transition="false" value="budget">
      <project-report-budget :planning="planning" @open-element="$emit('open-element', $event)"></project-report-budget>
    </v-window-item>

    <!-- TAB USERS -->
    <v-window-item :transition="false" :reverse-transition="false" value="users">
      <project-report-users :planning="planning" @reload-planning="$emit('reload-planning', $event)"></project-report-users>
    </v-window-item>

    <!-- TAB RISKS -->
    <v-window-item :transition="false" :reverse-transition="false" value="risks">
      <premium-section feature="risks">
        <project-report-risks :planning="planning" @update="$emit('update', $event)"></project-report-risks>
      </premium-section>
    </v-window-item>

    <!-- CUSTOM : HORIS MILESTONES SYNTHESIS -->
    <v-window-item v-for="customTab in customTabs" :key="customTab.id" :transition="false" :reverse-transition="false" :value="customTab.id">
      <client-custom-component :name="customTab.component" :planning="planning" :custom-tab="customTab"></client-custom-component>
    </v-window-item>
  </v-window>
</template>

<script>
  import clientConfig from '@/client_customs/config';
  import ProjectSheet from '@/components/ProjectSheet/ProjectSheet.vue';
  import ProjectReportFiles from './ProjectReportFiles.vue';
  import ProjectReportBudget from './ProjectReportBudget.vue';
  import ProjectReportUsers from './ProjectReportUsers.vue';
  import ProjectReportRisks from './ProjectReportRisks.vue';

  export default {
    components: {
      ProjectSheet,
      ProjectReportFiles,
      ProjectReportBudget,
      ProjectReportUsers,
      ProjectReportRisks,
    },
    props: {
      planning: { type: Object, required: true },
      openedTabIndex: { type: String, default: 'projectsheet' },
    },
    emits: ['update:opened-tab-index', 'open-element', 'open-project-report', 'update', 'reload-planning'],
    data() {
      return {
        customTabs: clientConfig.projectsheet?.customTabs,
      };
    },
  };
</script>
